'use strict';
var UA = require('../internals/environment-user-agent');

module.exports = /MSIE|Trident/.test(UA);



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/environment-is-ie-or-edge.js
// module id = 660
// module chunks = 13